import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "width", "height"]
const _hoisted_3 = ["src", "width", "height"]
const _hoisted_4 = {
  key: 0,
  class: "swiper-pagination"
}

import { register } from 'swiper/element/bundle';
import { type SwiperOptions } from 'swiper/types';
import { ref, onMounted } from 'vue';

interface Slide {
  image_url: string;
  title?: string;
  url?: string;
  series_name?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'slider',
  props: {
    slidesJson: {},
    imageWidth: {},
    imageHeight: {},
    effect: { default: 'slide' },
    pagination: { type: Boolean, default: true },
    navigation: { type: Boolean, default: true },
    spaceBetween: { default: 0 },
    slidesPerView: { default: 1 },
    slidesPerViewSp: { default: 1 },
    slidesPerGroup: { default: 1 }
  },
  setup(__props: any) {

const props = __props;
const containerEl = ref();
const slides: Slide[] = JSON.parse(props.slidesJson);

// register Swiper custom elements
if (slides.length > 1) {
  register();
}

onMounted(async () => {
  if (slides.length > 1) {
    const options: SwiperOptions = {
      loop: true,
      speed: 600,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      centeredSlides: true,
      spaceBetween: props.spaceBetween,
      slidesPerView: props.slidesPerViewSp,
      slidesPerGroup: props.slidesPerGroup,
      breakpoints: {
        640: {
          slidesPerView: props.slidesPerView,
        },
      },
    };

    if (props.effect === 'fade') {
      options.effect = 'fade';
      options.speed = 1300;
      options.fadeEffect = {
        crossFade: true,
      };
    }

    if (props.pagination) {
      options.pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      };
    }

    if (props.navigation) {
      options.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };
    }

    if (containerEl.value) {
      Object.assign(containerEl.value, options);
      containerEl.value.initialize();
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.swiperContainer)
  }, [
    _createElementVNode("swiper-container", {
      ref_key: "containerEl",
      ref: containerEl,
      init: "false"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
        return (_openBlock(), _createElementBlock("swiper-slide", { key: index }, [
          (slide.url)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.$style.image)
              }, [
                _createElementVNode("a", {
                  href: slide.url
                }, [
                  _createElementVNode("img", {
                    src: slide.image_url,
                    alt: "",
                    width: _ctx.imageWidth,
                    height: _ctx.imageHeight
                  }, null, 8, _hoisted_2)
                ], 8, _hoisted_1)
              ], 2))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(_ctx.$style.image)
              }, [
                _createElementVNode("img", {
                  src: slide.image_url,
                  alt: "",
                  width: _ctx.imageWidth,
                  height: _ctx.imageHeight
                }, null, 8, _hoisted_3)
              ], 2)),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (slide.series_name)
            ? (_openBlock(), _createElementBlock("p", {
                key: 2,
                class: _normalizeClass(_ctx.$style.seriesTitle)
              }, _toDisplayString(slide.series_name), 3))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (slide.title)
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                class: _normalizeClass(_ctx.$style.title)
              }, _toDisplayString(slide.title), 3))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512),
    _cache[5] || (_cache[5] = _createTextVNode()),
    (_ctx.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    (_ctx.navigation)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-button-navigation swiper-button-prev" }, null, -1)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "swiper-button-navigation swiper-button-next" }, null, -1))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})